import { useEffect, useState } from 'react';
import { protectedResources } from '../../authConfig';
import { useFetchWithMsal } from '../../hooks/useFetchWithMsal';
import { useParams } from 'react-router-dom';
import { getReportURL } from '../../utils/reportUtil';

interface ViewReportProps {
    submittedKitId?: number,
    reportId?: number,
    children?: React.ReactNode
}

const ViewReport = (props: ViewReportProps) => {
    const params = useParams();
    const { execute } = useFetchWithMsal({
        scopes: protectedResources.scopes.admin
    });
    const [reportUrl, setReportUrl] = useState("");
    const [loadingPdf, setLoadingPdf] = useState(true);

    const getReport = () => {
        let endpoint = protectedResources.apiReport.endpoint;
        if (props.reportId) {
            endpoint += "GetDocumentByReportId?Id=" + props.reportId;
        } else if (params.ReportId) {
            endpoint += "GetDocumentByReportId?Id=" + params.ReportId;
        } else if (props.submittedKitId) {
            endpoint += "GetDocumentBySubmittedKitId?Id=" + props.submittedKitId;
        } else {
            return;
        }

        getReportURL(execute, endpoint, (url: string) => {
            setReportUrl(url);
            setLoadingPdf(false);
        }, () => {
            console.log("Somethign went wrong attempting to open report " + props.reportId)
        });
    }

    useEffect(() => {
        getReport();
    }, [execute]);

    return (
        <>
            {loadingPdf ?
                "Your report is loading" :
                <iframe style={{ height: "85vw", width: "100%" }} title="PVS Report" src={reportUrl}></iframe>
            }
        </>
    );
}


export default ViewReport;